import { PayloadAction } from '@reduxjs/toolkit';
import {
  formNames,
  onAddApplicationBodyData,
  onGetShippingLocationInfoListBodyData,
  onOnlineApplicationQueryBodyData,
  OnUpdateApplicationBodyData,
  onUpdateCustomerAddressReqBodyData,
} from 'Config';
import { replace, RouterState } from 'connected-react-router';
import {
  CardApplicationUpdateModel,
  OnAddApplicationModel,
  ProductPriceModel,
  OnGetShippingLocationInfoListModel,
  OnUpdateCustomerAdressModel,
} from 'Models';
import { cityListItem } from 'Models/GetCityListModel';
import { townOtherListItem } from 'Models/GetTownListOtherModel';
import { routePath } from 'Navigator/routes';
import { masterPassPaymentNormalize } from 'Normalize';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  onAddApplication,
  onGetShippingLocationInfoList,
  OnGetSubProductList,
  onUpdateApplication,
  onUpdateCustomerAdress,
  productPrice,
} from 'Services/Queries';
import { AccountState, storeAccount, activeUserAdressType } from 'Stores/Account';
import { CardTransactionsState, storeCardTransactions } from 'Stores/CardTransactions';
import {
  CreditCardTransactionsState,
  creditCardTransactionsStore,
  onGetMasterpassTokenRequest,
} from 'Stores/CreditCardTransactions';
import { resetFormError, setFormError } from 'Stores/Form';
import { showToastify } from 'Stores/Toastify';
import { UserState, userStore } from 'Stores/User';
import { getEnvironment, isBelbimRequestSuccess, MasterPassRefType, MasterPassTokenEnum } from 'Utils';
import { refTrnType } from 'Views/AddBalanceToCard/constant';
import { resendCargoSuccess } from '.';

import {
  applicationStore,
  getProductPriceFail,
  getProductPriceRequest,
  getProductPriceSuccess,
  getSubProductList,
  onAddApplicationFail,
  onAddApplicationRequest,
  onAddApplicationSuccess,
  onGetShippingLocationInfoListFail,
  onGetShippingLocationInfoListRequest,
  onGetShippingLocationInfoListSuccess,
  onGetSubProductListSuccess,
  onUpdateApplicationFail,
  onUpdateApplicationRequest,
  onUpdateApplicationSuccess,
  resendCargoFail,
  resendCargoRequest,
  setApplicationData,
} from './slices';
import { ApplicationProcessState } from './types';
import { SubProductResponseModel } from 'Models/OnGetSubProductList';

function createRequestBodyData(
  activeCardShippingFee: number,
  activeUpStateShippingFee: number,
  data: onAddApplicationBodyData,
  otherTownList: townOtherListItem[],
  cityList: cityListItem[],
  activeUserAdress?: activeUserAdressType,
  h?: string
) {
  const otherTownCode = otherTownList?.find((item: townOtherListItem) => {
    return (
      item?.TownName?.toLocaleLowerCase('tr-TR') ===
      String(data.AddressDetail?.TownCode || data.AddressDetail?.Town)?.toLocaleLowerCase('tr-TR')
    );
  });

  const otherCityCode = cityList?.find((item: cityListItem) => item.CityId === String(data.AddressDetail?.CityCode));
  let requestBodyData = { ...data };

  if (!data.ApplicationCenterId) {
    requestBodyData = {
      ...data,
      AddressDetail: {
        AddressType: 9,
        CountryCode: 90,
        City: otherCityCode?.CityName,
        CityCode: data.AddressDetail?.CityCode,
        TownCode: otherTownCode ? Number(otherTownCode?.TownId) : Number(data.AddressDetail?.TownCode),
        District: data.AddressDetail?.District,
        Street: data.AddressDetail?.Street,
        AddressDetail: data.AddressDetail?.AddressDetail,
        PostalCode: Number(data.AddressDetail?.PostalCode),
        ApartmentNumber: data.AddressDetail?.ApartmentNumber || activeUserAdress?.apartmentNumber,
        BuildingNumber: data.AddressDetail?.BuildingNumber || activeUserAdress?.buildingNumber,
      },
      IsFree: false,
      ShippingFee: data?.AddressDetail?.CityCode === 34 ? activeCardShippingFee : activeUpStateShippingFee,
      SubProductCode: '',
      ApplicationCenterId: 0,
      h,
    };
  } else {
    requestBodyData = {
      ...data,
      AddressDetail: {
        AddressType: 9,
        CountryCode: 90,
        City: otherCityCode?.CityName,
        CityCode: data.AddressDetail?.CityCode,
        TownCode: otherTownCode ? Number(otherTownCode?.TownId) : Number(data.AddressDetail?.TownCode),
        District: data.AddressDetail?.District,
        Street: data.AddressDetail?.Street,
        AddressDetail: data.AddressDetail?.AddressDetail,
        PostalCode: Number(data.AddressDetail?.PostalCode),
        ApartmentNumber: data.AddressDetail?.ApartmentNumber || activeUserAdress?.apartmentNumber,
        BuildingNumber: data.AddressDetail?.BuildingNumber || activeUserAdress?.buildingNumber,
      },
      IsFree: false,
      // ReceiptNumber: '',
      ShippingFee: 0,
      SubProductCode: '',
      h,
    };
  }

  return requestBodyData;
}

function* handleonAddApplicationRequestSaga() {
  try {
    yield put(resetFormError());

    const appData: ApplicationProcessState = yield select(applicationStore);
    const userData: UserState = yield select(userStore);
    const accountData: AccountState = yield select(storeAccount);
    const cardData: CardTransactionsState = yield select(storeCardTransactions);
    const creditCardData: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
    const { userTempCreditCard, macroMerchantId, isUserAddedCreditCardWithMasterpass } = creditCardData;
    const {
      updateApplicationId,
      paymentInformationData,
      isShipping,
      productPriceResponse,
      applicationCard,
      activeApplicationData,
      h,
      activeCardShippingFee,
      activeUpStateShippingFee,
      cardApplicationStatus,
    } = appData;
    const { HashData, CustodyCustomerNumber, SubProductCode } = cardData;
    const { customerNumber, sessionToken } = userData;
    const { cityList, otherTownList, activeUserAdress } = accountData;

    // ⚠️ `!` NON-NULL ASSERTION RUNTIME'DA HİÇBİR ŞEY YAPMAZ.
    //
    // Kargo ücretleri `setActiveShippingPrice` ile doluyor ve plus/IKT_STD dalı onu
    // atlıyordu (bkz. Stores/CardTransactions/sagas.ts). Alanlar `undefined` kalınca
    // aşağıdaki `.toFixed(2)` TypeError fırlatıyor, hata sessiz catch'e düşüyor ve
    // Masterpass token isteği HİÇ atılmıyordu — kullanıcı "Ödemeye geç"e basınca
    // ekranda hiçbir şey olmuyordu.
    const localShippingFee = Number(activeCardShippingFee ?? 0);
    const upStateShippingFee = Number(activeUpStateShippingFee ?? 0);

    // ⚠️ FİYAT BİLİNMEDEN ÖDEME BAŞLATILMAZ — ama erken kesme KOŞULSUZ OLAMAZ.
    //
    // `onAddApplicationRequest` ikinci bir yerden daha dispatch ediliyor:
    // Views/CardApplicationsDetail/CardApplicationRejectImage — reddedilen fotoğrafı
    // yeniden yükleme akışı. O ekran `clearApplicationData` ile productPriceResponse'u
    // siliyor ve fiyat sorgusu hiç yapmıyor; bugün NaN üretiliyor ama KULLANILMIYOR
    // çünkü `handleOnUpdateApplication` o pathname'de token isteğini hiç yapmadan
    // başarı ekranına yönlendiriyor. Koşulsuz return o akışı öldürürdü.
    const routerState: RouterState = yield select((state: any) => state.router);
    const isRejectImageFlow = routerState?.location?.pathname === routePath.cardApplicationsDetail;

    const rawPrice = cardApplicationStatus === 6 ? 0 : productPriceResponse?.data?.ProductPrice;
    const hasPrice = typeof rawPrice === 'number' && !Number.isNaN(rawPrice);

    if (!isRejectImageFlow && !hasPrice) {
      yield put(setFormError({ errorCode: 'web_generic_error_desc', formName: formNames.paymentStep }));
      yield put(onAddApplicationFail());
      return;
    }

    const price: number = hasPrice ? (rawPrice as number) : 0;

    let requestBody = createRequestBodyData(
      localShippingFee,
      upStateShippingFee,
      activeApplicationData!,
      otherTownList!,
      cityList!,
      activeUserAdress,
      h
    );

    const cleanSrc = activeApplicationData?.DocumentData?.includes('charset=utf-8;')
      ? activeApplicationData?.DocumentData?.replace('charset=utf-8;', '')
      : activeApplicationData?.DocumentData;

    const src = cleanSrc ? cleanSrc?.replace(/^data:image\/(png|jpg|jpeg);base64,/, '') : '';

    const relationData = {
      HashData,
      CustodyCustomerNumber,
      SubProductCode,
    };

    requestBody = {
      ...requestBody,
      CustomerNumber: customerNumber,
      SessionToken: sessionToken,
      ProductCode: applicationCard?.ProductCode,
      DocumentData: src || '',
      FileName: activeApplicationData?.FileName || '',
      MimeType: activeApplicationData?.MimeType || '',
      ReceiptNumber: activeApplicationData?.ReceiptNumber,
      ...relationData,
    };

    if (appData?.campusId > 0) {
      requestBody.ShippingLocationDetailId = appData?.campusId;
      requestBody.ApplicationCenterId = 0;
    }

    if (!updateApplicationId) {
      const response: OnAddApplicationModel = yield call(() => onAddApplication(requestBody));
      const { requestSuccess, responseCode, errorMessage } = isBelbimRequestSuccess(response);
      if (requestSuccess) {
        yield put(onAddApplicationSuccess(response.data.ApplicationId));
        const vposAmount = !isShipping
          ? Number(price.toFixed(2))
          : Number(price.toFixed(2)) +
            Number(
              requestBody?.AddressDetail?.CityCode === 34
                ? localShippingFee.toFixed(2)
                : upStateShippingFee.toFixed(2)
            );
        yield put(
          onGetMasterpassTokenRequest({
            // ⚠️ İKİ KOŞUL BİRLİKTE. Bu alan saga'da `activeSelectedCard` olur ve
            // `cardNumber` doluysa KAYITSIZ kart servisi (`directPayment`) seçilir.
            // Kart Masterpass'e KAYDEDİLDİĞİNDE de `setTempMasterPassCardActive`
            // reducer'ı `userTempCreditCard`'ı ham `cardNumber` içeren kartla
            // dolduruyor — tek başına `userTempCreditCard` yetmiyor.
            // Çalışan TL yükleme akışı da ikisini birlikte kontrol ediyor
            // (Views/AddBalanceToCard/LoadBalance/LoadBalance.tsx).
            ...(!isUserAddedCreditCardWithMasterpass &&
              userTempCreditCard && { activeSelectedCreditCard: paymentInformationData }),
            SessionToken: sessionToken,
            CustomerNumber: customerNumber,
            TokenType: MasterPassTokenEnum.REGISTER_PURCHASE,
            RefTrnType: MasterPassRefType.CARD_APPLICATION_BALANCE,
            Amount: vposAmount,
            CommissionAmount: 0,
            DeviceType: '10',
            PanMasked: paymentInformationData?.maskedCardNumber,
            RefTrnId: response.data.ApplicationId,
            MacroMerchantId: getEnvironment() ? '05878207920408103103242' : '06580207920724020852449',
            request: {
              data: masterPassPaymentNormalize(vposAmount, paymentInformationData?.cardAlias),
            },
          })
        );
      } else {
        yield put(setFormError({ errorCode: errorMessage, formName: formNames.paymentStep }));
        yield put(onAddApplicationFail());
      }
    } else {
      const vposAmountUpdate = !isShipping
        ? Number(price.toFixed(2))
        : Number(price.toFixed(2)) +
          Number(
            requestBody?.AddressDetail?.CityCode === 34
              ? localShippingFee.toFixed(2)
              : upStateShippingFee.toFixed(2)
          );
      const req: any = {
        ...(!isUserAddedCreditCardWithMasterpass &&
          userTempCreditCard && { activeSelectedCreditCard: paymentInformationData }),
        SessionToken: sessionToken,
        CustomerNumber: customerNumber,
        TokenType: MasterPassTokenEnum.REGISTER_PURCHASE,
        RefTrnType: cardApplicationStatus === 6 ? refTrnType.ikinciKargoBasvurusu : refTrnType.yeniKartBasvurusu,
        Amount: vposAmountUpdate,
        CommissionAmount: 0,
        DeviceType: '10',
        PanMasked: paymentInformationData?.maskedCardNumber,
        RefTrnId: updateApplicationId,
        MacroMerchantId: getEnvironment() ? '05878207920408103103242' : '06580207920724020852449',
        request: {
          data: masterPassPaymentNormalize(vposAmountUpdate, paymentInformationData?.cardAlias),
        },
      };
      const calculatedShippingFee = isShipping
        ? requestBody?.AddressDetail?.CityCode === 34
          ? localShippingFee
          : upStateShippingFee
        : 0;
      const body: OnUpdateApplicationBodyData = {
        ...requestBody,
        ApplicationId: Number(updateApplicationId),
        AppCenter: isShipping ? 0 : activeApplicationData?.ApplicationCenterId, //
        CustomerNumber: customerNumber,
        DocumentData: src || '',
        FileName: activeApplicationData?.FileName || '',
        MimeType: activeApplicationData?.MimeType || '',
        SessionToken: sessionToken,
        ShippingFee: calculatedShippingFee,
        ShippingLocationDetailId:
          requestBody.ApplicationCenterId! > 0 || isShipping
            ? 0
            : appData?.campusId > 0
            ? appData?.campusId
            : activeApplicationData?.ShippingLocationDetailId,
      };

      yield put(onUpdateApplicationRequest({ body, req }));
    }
  } catch (error) {
    // ⚠️ BURASI SESSİZDİ. `activeCardShippingFee!.toFixed(2)` TypeError'ı buraya
    // düşüp hiçbir iz bırakmadan yutuluyordu; kullanıcı "Ödemeye geç"e basıyor,
    // ekranda hiçbir şey olmuyordu. Hata artık ödeme adımının formuna yazılıyor.
    console.error('[CardApplication] onAddApplication akışı hata verdi →', error);
    yield put(setFormError({ errorCode: 'web_generic_error_desc', formName: formNames.paymentStep }));
    yield put(onAddApplicationFail());
  }
}

function* handleProductPrice({ payload }: PayloadAction<onOnlineApplicationQueryBodyData>) {
  try {
    const response: ProductPriceModel = yield call(() => productPrice(payload));
    const { requestSuccess } = isBelbimRequestSuccess(response);
    if (requestSuccess) {
      yield put(
        setApplicationData({
          ApplicationReasonId: response.data.ApplicationReasonId,
          ExpenseAmount: response.data.ExpenseAmount,
        })
      );

      yield put(getProductPriceSuccess(response));
    } else {
      yield put(getProductPriceFail());
    }
  } catch (error) {
    yield put(getProductPriceFail());
  }
}

function* handleOnUpdateApplication({ payload }: PayloadAction<OnUpdateApplicationBodyData | any>) {
  try {
    yield put(resetFormError());

    const routerState: RouterState = yield select((state: any) => state.router);
    const appData: ApplicationProcessState = yield select(applicationStore);

    let pathname = routerState?.location?.pathname;
    const { productPriceResponse } = appData;

    let requestBody = payload?.body || payload;

    const src = requestBody?.DocumentData
      ? requestBody.DocumentData?.replace(/^data:image\/(png|jpg|jpeg);charset=utf-8;base64,/, '')
      : undefined;

    // Destructure ile default değerler ata
    const { DocumentData = '', FileName = '', MimeType = '', ...restRequestBody } = requestBody;

    requestBody = {
      ...restRequestBody,
      DocumentData: src || '',
      FileName: FileName || '',
      MimeType: MimeType || '',
      ExpenseAmount: productPriceResponse?.data.ExpenseAmount,
    };
    if (appData?.campusId > 0) {
      requestBody.ShippingLocationDetailId = appData?.campusId;
      requestBody.ApplicationCenterId = 0;
    }
    const response: CardApplicationUpdateModel = yield call(() => onUpdateApplication(requestBody));
    const { requestSuccess } = isBelbimRequestSuccess(response);
    const userData: CardTransactionsState = yield select(storeCardTransactions);
    const { activeCardApplicationDetail } = userData;
    if (requestSuccess) {
      if (pathname === routePath.cardApplicationsDetail) {
        yield put(
          replace(routePath.cardApplicationUpdateSuccess, {
            id: response.data.ApplicationId,
            pc: activeCardApplicationDetail?.ProductCode,
            campusId: activeCardApplicationDetail?.ShippingLocationDetailId,
          })
        );
      } else {
        yield put(onGetMasterpassTokenRequest(payload.req));
      }

      yield put(onUpdateApplicationSuccess());
    } else {
      yield put(
        showToastify({
          toastMessage: response.data.ResponseDescription,
          type: 'error',
        })
      );
      yield put(onUpdateApplicationFail());
    }
  } catch (error) {
    yield put(onUpdateApplicationFail());
  }
}

function* handleOnGetShippingLocationInfoListRequest({
  payload,
}: PayloadAction<onGetShippingLocationInfoListBodyData>) {
  try {
    const response: OnGetShippingLocationInfoListModel = yield call(() => onGetShippingLocationInfoList(payload));
    const { requestSuccess } = isBelbimRequestSuccess(response);
    if (requestSuccess) {
      yield put(onGetShippingLocationInfoListSuccess(response));
    } else {
      yield put(onGetShippingLocationInfoListFail());
    }
  } catch (error) {
    yield put(onGetShippingLocationInfoListFail());
  }
}

function* handleGetSubProductList({ payload }: PayloadAction<any>) {
  try {
    const response: SubProductResponseModel = yield call(() => OnGetSubProductList(payload));
    if (response?.data?.SubProductList) {
      yield put(onGetSubProductListSuccess(response?.data?.SubProductList));
    } else {
      yield put(onGetSubProductListSuccess([]));
    }
  } catch (error) {
    yield put(onGetSubProductListSuccess([]));
  }
}

function* handleResendCargoRequest({ payload }: PayloadAction<onUpdateCustomerAddressReqBodyData>) {
  try {
    const appData: ApplicationProcessState = yield select(applicationStore);
    const userData: UserState = yield select(userStore);
    const { updateApplicationId, paymentInformationData, activeCardShippingFee, activeUpStateShippingFee } = appData;
    const { customerNumber, sessionToken } = userData;
    const creditCardData: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
    const { userTempCreditCard, isUserAddedCreditCardWithMasterpass } = creditCardData;

    const response: OnUpdateCustomerAdressModel = yield call(() => onUpdateCustomerAdress(payload));
    const { requestSuccess, errorMessage } = isBelbimRequestSuccess(response);
    if (requestSuccess) {
      // ⚠️ ŞEHRE GÖRE ÜCRET. Burada şehir koduna BAKILMADAN daima İstanbul içi ücret
      // kullanılıyordu; il dışı adreste yanlış tutar tahsil edilirdi. Ayrım yeni
      // başvuru dalıyla aynı (`CityCode === 34`).
      const rawShippingFee = payload?.CityCode === 34 ? activeCardShippingFee : activeUpStateShippingFee;

      // ⚠️ `??` — `0` geçerli bir ücret, `||` onu da elerdi.
      const shippingAmount = Number(rawShippingFee ?? NaN);
      if (Number.isNaN(shippingAmount)) {
        // Kargo ücreti bilinmeden ödeme başlatılmaz. Eskiden `!` assertion'ı
        // TypeError fırlatıp aşağıdaki catch'te sessizce yutuluyordu.
        yield put(setFormError({ errorCode: 'web_generic_error_desc', formName: formNames.paymentStep }));
        yield put(resendCargoFail());
        return;
      }
      const shippingAmountRounded = Number(shippingAmount.toFixed(2));

      yield put(
        onGetMasterpassTokenRequest({
          // Yeni başvuru dalıyla aynı gerekçe: kayıtlı kart `directPayment`'a düşmemeli.
          ...(!isUserAddedCreditCardWithMasterpass &&
            userTempCreditCard && { activeSelectedCreditCard: paymentInformationData }),
          SessionToken: sessionToken,
          CustomerNumber: customerNumber,
          TokenType: MasterPassTokenEnum.REGISTER_PURCHASE,
          RefTrnType: refTrnType.ikinciKargoBasvurusu,
          Amount: shippingAmountRounded,
          CommissionAmount: 0,
          DeviceType: '10',
          PanMasked: paymentInformationData?.maskedCardNumber,
          RefTrnId: updateApplicationId,
          MacroMerchantId: getEnvironment() ? '05878207920408103103242' : '06580207920724020852449',
          request: {
            data: masterPassPaymentNormalize(shippingAmountRounded, paymentInformationData?.cardAlias),
          },
        })
      );
      yield put(resendCargoSuccess());
    } else {
      // ⚠️ BU DAL SESSİZDİ. Aynı fonksiyonun diğer iki hata çıkışı (kargo ücreti
      // guard'ı ve catch) sesli hale getirilmişti, adres güncelleme hatası
      // atlanmıştı: kullanıcı "Ödemeye geç"e basıyor, spinner dönüp kayboluyor,
      // ekranda hiçbir şey olmuyordu.
      yield put(
        setFormError({ errorCode: errorMessage || 'web_generic_error_desc', formName: formNames.paymentStep })
      );
      yield put(resendCargoFail());
    }
  } catch (error) {
    // ⚠️ YANLIŞ ACTION'DI. `onGetShippingLocationInfoListFail` reducer'ı no-op
    // olduğu için `resendCargoRequest`'in açtığı `loading` hiç kapanmıyor ve
    // kullanıcı kapatılamayan global spinner'da kilitleniyordu.
    console.error('[CardApplication] resendCargo akışı hata verdi →', error);
    yield put(setFormError({ errorCode: 'web_generic_error_desc', formName: formNames.paymentStep }));
    yield put(resendCargoFail());
  }
}

function* cardApplicationSagaWatcher() {
  yield takeLatest(onAddApplicationRequest, handleonAddApplicationRequestSaga);
  yield takeLatest(getProductPriceRequest, handleProductPrice);
  yield takeLatest(onUpdateApplicationRequest, handleOnUpdateApplication);
  yield takeLatest(onGetShippingLocationInfoListRequest, handleOnGetShippingLocationInfoListRequest);
  yield takeLatest(resendCargoRequest, handleResendCargoRequest);
  yield takeLatest(getSubProductList, handleGetSubProductList);
}
export default cardApplicationSagaWatcher;
